module.exports = __webpack_public_path__ + "static/media/brad-wrenn.e14de5da.md";